import * as types from './types'

export function loadTaskManagementList(lists) {
  return {
    type: types.FECTH_TASK_MANAGEMENT_LIST,
    payload:{
        "lists":lists
    }
  };
}